import { PaneArea, RequireByKey, TextAttrs as TextAttrsRaw } from '../../../../types/shared'
import Callout, { ICalloutAttrs } from '../../../canvas/callout/callout_v1'
import { StyleDialogOpener } from '../../../modals/element_style'
import ElementModel from '../../../models/element'
import PaneModel from '../../../models/pane'

type Area = PaneArea
type TextAttrs = RequireByKey<TextAttrsRaw, 'text' | 'textAlign' | 'fillStyle' | 'border'>
type Attrs = ICalloutAttrs & TextAttrs
type PartialAttrs = Partial<Attrs>

class CalloutCreator extends Callout<Attrs> {
  isCreator = true
  openStyleDialog: StyleDialogOpener<CalloutCreator>

  constructor(
    startArea: Area,
    values: PartialAttrs,
    model: PaneModel,
    openStyleDialog: StyleDialogOpener<CalloutCreator>,
    toolsCallback: () => void
  ) {
    super(values, model)

    this.openStyleDialog = openStyleDialog

    const width = this.model.scale.x.width(30)
    const height = this.model.scale.y.height(-20)
    this.attrs.x1 = startArea.x
    this.attrs.y1 = startArea.y
    this.attrs.x2 = startArea.x + width
    this.attrs.y2 = startArea.y + height
    this.attrs.text = ''
    this.isCreatorDialogOpen = true

    setTimeout(
      () =>
        this.openStyleDialog(
          this,
          (values) => {
            this.set(values)
            this.release()
            this.replaceMyself(Callout.fromObject<Callout>(this.attrs, this.model))
            toolsCallback()
          },
          () => {
            const instance = ElementModel.findByAttribute<ElementModel>('instance', this)
            instance?.destroy()
          }
        ),
      0
    )

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }
}

export default CalloutCreator
